import React from 'react';
import PropTypes from 'prop-types';
import {Modal} from 'react-bootstrap';
import {EditTask} from '../';

class DashboardCalendarModal extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			editing_task : false
		}
		
		this.handleEditTask = this.handleEditTask.bind(this);
		this.hideEditTask = this.hideEditTask.bind(this);
	}

	handleEditTask() {
		this.setState({editing_task : true})
	}

	hideEditTask() {
		this.setState({editing_task : false})
		this.props.onHide()
	}

	render() {
		let current_event = {
			title : this.props.current_event.title,
			start : this.props.current_event.start,
			end : this.props.current_event.end
		}

		let task = {
			_id : this.props.current_event._id,
			text : this.props.current_event.title,
			due_date : this.props.current_event.start
		}

		return (
			<div className='dashboard-calendar-modal-conatiner'>
				<EditTask 
					show={this.state.editing_task}
					hide={this.hideEditTask}
					task={task}
				/>
				<Modal 
					show={this.props.show_event_modal}
					onHide={this.props.onHide}
					bsSize='sm'>
					<div className='panel'>
						<div className='panel-body'>
							<div className="thumb-info mb-md">
		            <div className="thumb-info-title">
		              <span className="thumb-info-inner">Task Details</span>
		            </div>
		          </div>
							<div className='col-md-12'>
								<div className='row'>
									<h4 className='text-muted'>Details :</h4>
									<hr className='dotted short' />
								</div>
								<div className='row'>
									<div className='col-md-11 col-md-offset-1'>
										{current_event.title || ''}
									</div>
									<hr className='dotted short' />
								</div>
								<div className='row'>
									<h4 className='text-muted'>Due Date :</h4>
									<hr className='dotted short' />
								</div>
								<div className='row'>
									<div className='col-md-11 col-md-offset-1 mb-lg'>
										{new Date(current_event.start).toDateString() || ''}
									</div>
									<hr className='dotted short' />
								</div>
								<div className='row'>
									<div 
										className='btn btn-primary btn-block'
										onClick={this.handleEditTask}
										>
										Edit Task
									</div>
									<div
										className='btn btn-default btn-block'
										onClick={this.props.onHide}
										>
										Cancel
									</div>
								</div>
							</div>
						</div>
					</div>
				</Modal>
			</div>
			)
	}
}

export default DashboardCalendarModal


// WEBPACK FOOTER //
// ./src/browser/components/dashboard/dashboardCalendarTasksModal.js